<template>
  <div class="tui-msg-box" style="z-index:9999999999">
    <div @click="$showSubwx(false)">
      <i class="el-icon-circle-close" style="font-size:35px;color:#ffffff;margin-bottom:10px"></i>
    </div>
    <van-image width="70%" :src="require('../assets/subwxpic.png')" :show-loading="true" />
    <!-- <van-image
      width="70%"
      :src="require('../assets/gkb.jpg')"
      :show-loading="true"
      @click="toadv"
      radius="10px"
    />
    <div class="tui-msg-item">
      <div class="tui-msg-name">关注后:</div>
      <div class="tui-msg-content" style="margin: 10rpx;">1.观看更多招办宣讲</div>
      <div class="tui-msg-content" style="margin: 10rpx;">2.接收报名宣讲提醒</div>
     
    </div>-->
  </div>
</template>

<script>
export default {
  data () {
    return {



    };
  },

  mounted () {
    let that = this;
    var hiddenProperty = 'hidden' in document ? 'hidden' :
      'webkitHidden' in document ? 'webkitHidden' :
        'mozHidden' in document ? 'mozHidden' :
          null;
    var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    var onVisibilityChange = function () {
      if (!document[hiddenProperty]) {
        console.log('页面激活');
      } else {
        console.log('页面隐藏')
      }
    }
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
  },
  methods: {
    
  }
}
</script>


<style scoped>
.tui-msg-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tui-msg-pic {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  margin-right: 24px;
}

.tui-msg-item {
  max-width: 500px;
  min-height: 80px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
}

.tui-msg-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 1;
  color: #262b3a;
}

.tui-msg-content {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 1;
  color: #9397a4;
}

.tui-msg-right {
  max-width: 120px;
  height: 88px;
  margin-left: auto;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}

.tui-msg-right.tui-right-dot {
  height: 76px;
  padding-bottom: 10px;
}

.tui-msg-time {
  width: 100%;
  font-size: 24px;
  line-height: 24px;
  color: #9397a4;
}
</style>


// WEBPACK FOOTER //
// src/components/subWx.vue